/** Escape a string for safe interpolation into an innerHTML template. Every
 * API-sourced string (device names, models, display names, SSIDs, labels)
 * must pass through this before meeting innerHTML — device_name/model are
 * attacker-influenced at registration time, and SSIDs come from whatever
 * networks are broadcasting near the phone. */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}

/** Wrap JSON tokens in .j-* spans (keys, strings, numbers, booleans/null) so
 * the check-in log's drawer can color-code them with theme variables.
 * Tokenizes the raw JSON and escapes each slice separately so escaping never
 * confuses the regex. */
export function highlightJson(json: string): string {
  const token = /("(?:\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*"(?:\s*:)?|\b(?:true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g;
  let out = '';
  let last = 0;
  for (const m of json.matchAll(token)) {
    out += escapeHtml(json.slice(last, m.index));
    const tok = m[0];
    let cls: string;
    if (tok.startsWith('"')) cls = tok.endsWith(':') ? 'j-key' : 'j-str';
    else if (tok === 'true' || tok === 'false') cls = 'j-bool';
    else if (tok === 'null') cls = 'j-null';
    else cls = 'j-num';
    out += `<span class="${cls}">${escapeHtml(tok)}</span>`;
    last = m.index + tok.length;
  }
  return out + escapeHtml(json.slice(last));
}
